import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animatedloading',
  templateUrl: './animatedloading.component.html',
  styleUrls: ['./animatedloading.component.scss'],
})
export class AnimatedloadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
